import { createFileRoute } from '@tanstack/react-router';
import { AuthCard, AuthShell } from '@/features/auth/layout/auth-layout';
import {
  ResetLinkDeadPanel,
  ResetPasswordForm,
} from '@/features/auth/forms/reset-password-form';
import { sanitizeToken } from '@/features/auth/validators/token-search';

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { token } = Route.useSearch();
  const validToken = sanitizeToken(token);

  return (
    <AuthShell brandPane>
      <AuthCard title={validToken ? 'Nouveau mot de passe' : undefined}>
        {validToken ? (
          <ResetPasswordForm token={validToken} />
        ) : (
          <ResetLinkDeadPanel />
        )}
      </AuthCard>
    </AuthShell>
  );
}
